import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState.js';

const prefillSlice = createSlice({
    name: 'prefill',
    initialState,
    reducers: {
        setEmail: (state, action) => {
            state.email = action.payload;
        },
    },
});
const { setEmail } = prefillSlice.actions;
var index = prefillSlice.reducer;

export { index as default, setEmail };
//# sourceMappingURL=index.js.map
